"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ACNotifications = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var antd_1 = require("antd");
var react_1 = require("react");
var ACButton_1 = require("./ACButton");
var ACNotifications = function (props) {
    var _a = props.items, items = _a === void 0 ? [] : _a;
    var _b = (0, react_1.useState)(false), visible = _b[0], setVisible = _b[1];
    var popoverContentStyle = {
        minWidth: '300px',
        maxWidth: '100%',
        maxHeight: '300px',
        overflow: 'auto',
    };
    var handleItemClick = function (event, item) {
        event.stopPropagation();
        if (props === null || props === void 0 ? void 0 : props.onNoticationClick) {
            props.onNoticationClick(item);
        }
        setVisible(false);
    };
    var handleVisibleChange = function (newVisible) {
        setVisible(newVisible);
    };
    var popoverContent = ((0, jsx_runtime_1.jsx)("div", { style: popoverContentStyle, children: items.length > 0 ? ((0, jsx_runtime_1.jsx)(antd_1.List, { itemLayout: "horizontal", dataSource: items, renderItem: function (item, index) { return ((0, jsx_runtime_1.jsx)(antd_1.List.Item, { onClick: function (event) { return handleItemClick(event, item); }, style: { cursor: 'pointer' }, children: (0, jsx_runtime_1.jsx)(antd_1.List.Item.Meta, { title: item === null || item === void 0 ? void 0 : item.title, description: item === null || item === void 0 ? void 0 : item.description }) }, index)); } })) : ((0, jsx_runtime_1.jsx)(antd_1.Empty, { image: antd_1.Empty.PRESENTED_IMAGE_SIMPLE })) }));
    return ((0, jsx_runtime_1.jsx)(antd_1.Popover, { className: props.className, content: popoverContent, trigger: "click", open: visible, onOpenChange: handleVisibleChange, placement: 'bottomRight', children: (0, jsx_runtime_1.jsx)(antd_1.Badge, { count: (items === null || items === void 0 ? void 0 : items.length) || 0, style: {
                zIndex: 1,
            }, children: (0, jsx_runtime_1.jsx)(ACButton_1.ACButton, { name: props === null || props === void 0 ? void 0 : props.name, variant: props === null || props === void 0 ? void 0 : props.variant, iconClassName: props === null || props === void 0 ? void 0 : props.iconClassName, className: props === null || props === void 0 ? void 0 : props.buttonClassName, onClick: function () { return setVisible(!visible); } }) }) }));
};
exports.ACNotifications = ACNotifications;
